import { usePrices } from '@/configs/general.configs';
import * as types from '../mutation-types'
import store from '..';

export default {
	namespaced: true,
	state: {
		materials: [],
		specialtyMaterials: []
	},

	actions: {
		fetchAll({ commit }, { name, materialFormId }) {
			return window.axios.get('/materials', {
				params: {
					name: name,
					materialFormId: materialFormId,
					withPrices: usePrices
				}
			})
				.then((response) => {
					commit(types.STORE_MATERIALS, response.data);
					return response.data
				})
		},

		fetchById({ commit }, { id }) {
			return window.axios.get(`/materials/${id}`).then((response) => {
				return response.data;
			})
		},

		fetchAllForSpecialtyVisits({ commit }, { fromDate, toDate }) {
			return window.axios.get('/materials/teams', {
				params: {
					employeeId: store.state.auth.self.employeeId,
					fromDate,
					toDate
				}
			}).then((response) => {
				commit(types.SPECIALTY_MATERIALS, response.data);
				return response.data;
			})
		},

		reset({ commit }) {
			commit(types.RESET_MATERIALS);
		}
	},

	mutations: {
		[types.STORE_MATERIALS](state, materials) {
			state.materials = materials;
		},

		[types.SPECIALTY_MATERIALS](state, specialtyMaterials) {
			const items = [];

			/* specialtyMaterials = [...specialtyMaterials, ...specialtyMaterials].map((e, i) => ({
				...e,
				workloadId: e.workloadId || [
					'4fdd4201-6fe1-4729-c1f1-08dc315b67a4',
					'b5d5d80f-f6e4-4bf8-c1f0-08dc315b67a4',
					'5833a134-217d-4cdd-c1f2-08dc315b67a4',
					'4b088b2e-3834-4bf2-c1ef-08dc315b67a4',
					'13672690-73bb-49ef-c1f4-08dc315b67a4',
					'1e173e4a-b317-4bf3-c1f3-08dc315b67a4'
				][Math.floor(Math.random() * 6)]
			})) */
			// grouping materials by specialty then workload
			specialtyMaterials.forEach(e => {
				// specialty group
				let specialtyGroup = items.find(c => c.specialtyId === e.specialtyId);
				if (!specialtyGroup) {
					specialtyGroup = {
						specialtyId: e.specialtyId,
						workloads: [],
						materials: []
					};
					items.push(specialtyGroup);
				}
				
				if (e.workloadId) {
					// workload group
					let workloadGroup =
						specialtyGroup.workloads.find(c => c.workloadId === e.workloadId);
					if (!workloadGroup) {
						workloadGroup = {
							workloadId: e.workloadId,
							materials: []
						};
						specialtyGroup.workloads.push(workloadGroup);
					}
					workloadGroup.materials.push({
						materialId: e.materialId,
						amount: e.amount
					});
				} else {
					specialtyGroup.materials.push({
						materialId: e.materialId,
						amount: e.amount
					});
				}
			});
			
			state.specialtyMaterials = items;
		},

		[types.RESET_MATERIALS](state) {
			state.materials = [];
		},
	},

	getters: {
		getMaterialById: state => id => state.materials.find(c => c.id === id),
		getMaterialByName: state => name => state.materials.find(c => c.name === name)
	}
}